import { render, staticRenderFns } from "./OnlineTrainingModules.vue?vue&type=template&id=405993d2"
import script from "./OnlineTrainingModules.vue?vue&type=script&lang=js"
export * from "./OnlineTrainingModules.vue?vue&type=script&lang=js"
import style0 from "./OnlineTrainingModules.vue?vue&type=style&index=0&id=405993d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports